import isEmpty from 'lodash/isEmpty';

export default function layoutFactory(props) {
  let layout: any = {};
  if (props.backgroundColor) {
    layout.backgroundColor = props.backgroundColor;
  }
  if (props.text) {
    layout.text = props.text;
  }
  if (props.layout) {
    layout = {
      ...layout,
      ...props.layout
    };
  }
  return isEmpty(layout) ? undefined : layout;
}
